import { atom } from "jotai";

export interface TemplateStateInterface {
    selectedTemplateID: string | null;
    selectedTemplateName: string | null;
}

export interface TemplateInterface {
    templateID: string | null;
    name: string | null;
}

const INITIAL_TEMPLATES_ATOM_VALUE = {
    selectedTemplateID: null,
    selectedTemplateName: null,
};

const INITIAL_TEMPLATE_VALUE = {
    templateID: null,
    name: null,
};

export const templatesAtom = atom(INITIAL_TEMPLATES_ATOM_VALUE);

export const setSelectedTemplate = (
    set,
    template: TemplateInterface = INITIAL_TEMPLATE_VALUE
) => {

    set((state) => {
        const newState = { ...state };

        newState.selectedTemplateID = template?.templateID;
        newState.selectedTemplateName = template?.name;

        return newState;
    });
};
